<template>
  <div>
    <div v-if="list.length > 0">
      <p class="total">共{{list.length}}人</p>
      <van-list v-model="isRefresh"
                :finished="finished"
                finished-text="没有更多了">
        <ul class="student-ul">
          <li v-for="item in list"
              :key="item.StudentID"
              class="student-li">
            <div class="head">
              <span v-if="item.Icon"><img :src="item.Icon"></span>
              <span v-else>{{xy.showName(item.StudentName)}}</span>
              <div class="name">
                <span class="top">{{item.StudentName}}</span>
                <span class="bottom">{{item.UserName}}</span>
              </div>
            </div>
            <div class="class-name">{{item.CoursePlanTableFullName}}</div>
          </li>
        </ul>
      </van-list>
    </div>
    <no-data v-else
             :needBg="true"
             class="footer"></no-data>
  </div>
</template>
<script>
import NoData from '@/components/noData/Index'
export default {
  name: 'MyStudentsList',
  components: {
    NoData
  },
  data () {
    return {
      sessionID: 0,
      courseInfo: '',

      //list
      isRefresh: false,// 是否加载中
      finished: false,// 加载是否完成
      list: [],
    }
  },
  computed: {
  },
  created () {
    this.sessionID = this.$route.query.curSessionId;
    this.courseInfo = this.$route.query.curCourseInfo;
    this.onLoad();
  },
  mounted () {
  },
  methods: {
    async onLoad () {
      let res = await this.xyapi.get(`${this.$store.state.apiPath}/api/MyStudents/GetStudents`, {
        sessionID: this.sessionID,
        curricula: this.courseInfo
      })
      if (res.success) {
        if (res.data.length > 0) {
          this.list = res.data;
        } else {
          //this.$toast.fail('未查询到学生');
        }
        this.finished = true;
      } else {
        this.$toast.fail(res.msg);
      }
      // 加载状态结束
      this.isRefresh = false;
    }

  },
}
</script>
<style lang="less" scoped>
.total {
  font-size: 30px;
  color: #999;
  padding: 0 20px;
  margin: 20px 0 0;
}
.student-ul {
  padding: 15px;
  .student-li {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0px 2px 21px 0px rgba(197, 197, 197, 0.5);
    margin-bottom: 16px;
    padding: 22px 31px 22px 19px;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    .head {
      > span {
        float: left;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 64px;
        text-align: left;
        border-radius: 50%;
        background: @blue;
        font-size: 30px;
        color: #fff;
        > img {
          width: 100%;
          height: 100%;
          display: block;
          border-radius: 50%;
        }
      }
      .name {
        display: flex;
        flex-direction: column;
        padding-left: 30px;
        .top {
          margin: 14px 0 20px;
        }
        .bottom {
          color: #ccc;
        }
      }
    }
    .class-name {
      color: #999;
    }
  }
}
</style>
